import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { defaultLang } from '../config';
//
import enLocales from './en.json';
import kmLocales from './km.json';
import frLocales from './fr.json';

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      km: { translations: kmLocales },
      fr: { translations: frLocales }
    },
    lng: window.localStorage.getItem(`${process.env.REACT_APP_PROJECT_NAME}-i18nextLng`) || defaultLang.value,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    },
    detection: { lookupLocalStorage: `${process.env.REACT_APP_PROJECT_NAME}-i18nextLng` }
  });

export default i18n;
